import { render, staticRenderFns } from "./staffAssessment.vue?vue&type=template&id=5b9a6e9c&scoped=true&"
import script from "./staffAssessment.vue?vue&type=script&lang=js&"
export * from "./staffAssessment.vue?vue&type=script&lang=js&"
import style0 from "./staffAssessment.vue?vue&type=style&index=0&id=5b9a6e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a6e9c",
  null
  
)

export default component.exports